
    <bizz-search [class.pb-2]="isMobileView" #searchInput [disableCollapse]="false" [searchTerm]="searchTerm" (searchTermChange)="filterChange($event)">
    </bizz-search>
    
    @if(searchTerm.length){
        
        <ul class="m-0 flex max-h-[calc(100%_-_50px)] flex-col gap-2.5 overflow-y-auto" [class.h-full]="isMobileView" [class.search-popup]="!isMobileView">
            @for (item of filteredQuestions; track $index) {
                <li class="cursor-pointer [&>:first-child]:truncate p-1.5 rounded text-sm hover:bg-button-hover"  (click)="valueChange(item)" [innerHTML]="item.Question">
                </li>
            } @empty {
                
                <div class="flex h-full items-center justify-center" [class.h-52]="!isMobileView">
                    <p class="font-sans text-sm text-widget"> {{ 'NoResultsFound' | translate }}</p>
                </div>
                
            }
        </ul>
    }